import { Button, Flex, Select, Text } from "@jsq/ds/core";
import { Colors, Sizes } from "@jsq/ds/styles";
import { CaseResolutionNoteModal } from "../CaseResolutionNoteModal";
import type { ReviewerActionFooterProps } from "./types";

export const ReviewerActionFooter = ({
  assigneeName,
  showCancelAssignment,
  onCancelAssignment,
  showClaimAssignment,
  onClaimAssignment,
  showDecisionControls,
  conclusion,
  onConclusionChange,
  conclusionOptions,
  selectPlaceholder,
  selectTestId,
  onSubmit,
  isLoading,
  isReasonModalOpen,
  reasonModalTitle,
  reasonModalPlaceholder,
  onReasonModalClose,
  onReasonModalSubmit,
}: ReviewerActionFooterProps) => {
  const handleSelectChange = (value: string | number | string[] | number[]) => {
    if (typeof value === "string") {
      onConclusionChange(value);
    }
  };

  return (
    <>
      <Flex alignItems="center" justifyContent="space-between" gap={Sizes.MD}>
        <Flex alignItems="center" gap={Sizes.MD}>
          <Text variant="secondary-sm" color={Colors.Neutral600}>
            Assigned to{" "}
            <Text variant="regular-md" asSpan color={Colors.Primary600}>
              {assigneeName}
            </Text>
          </Text>
          {showCancelAssignment && onCancelAssignment && (
            <Button variant="neutral" disabled={isLoading} onClick={onCancelAssignment}>
              Cancel assignment
            </Button>
          )}
          {showClaimAssignment && onClaimAssignment && (
            <Button variant="neutral" disabled={isLoading} onClick={onClaimAssignment}>
              Assign to myself
            </Button>
          )}
        </Flex>
        {showDecisionControls && (
          <Flex alignItems="center" gap={Sizes.SM}>
            <Select
              placeholder={selectPlaceholder}
              position="up"
              value={conclusion}
              onChange={handleSelectChange}
              data-testid={selectTestId}
            >
              <Select.Section>
                {conclusionOptions.map((option) => (
                  <Select.Option key={option.value} value={option.value}>
                    {option.label}
                  </Select.Option>
                ))}
              </Select.Section>
            </Select>
            <Button variant="primary" disabled={!conclusion || isLoading} onClick={onSubmit}>
              Submit
            </Button>
          </Flex>
        )}
      </Flex>
      <CaseResolutionNoteModal
        isOpen={isReasonModalOpen}
        title={reasonModalTitle}
        placeholder={reasonModalPlaceholder}
        onClose={onReasonModalClose}
        onSubmit={onReasonModalSubmit}
      />
    </>
  );
};
